import { isUndefined } from 'lodash/fp';
import React, { useMemo } from 'react';

import { MARKERS_HEIGHT } from '../../shared/carousel/Carousel';
import { Spinner } from '../../shared/spinner/Spinner';
import styles from './Modules.module.scss';

interface ChartLoadingProps {
    dimensions?: {
        height: number;
        width: number;
    }
}

export const ChartLoading: React.FC<ChartLoadingProps> = ({ dimensions }) => {
    const wrapperWidth = useMemo(() => !isUndefined(dimensions) && dimensions.width || 0, [dimensions]);
    const wrapperHeight = useMemo(() => !isUndefined(dimensions) && dimensions.height - MARKERS_HEIGHT || 0, [dimensions]);
    return (
        <div className={styles.loadingWrapper} style={{ minWidth: `${wrapperWidth}px`, height: `${wrapperHeight}px` }}><Spinner /></div>
    );
};
